import { CONTACT } from "../../data/portfolio";
import { Heading, Row } from "./Primitives";

export default function ContactOutput() {
  return (
    <div>
      <Heading>cat contact.sh</Heading>
      <div className="space-y-0.5">
        <Row label="email">
          <a href={`mailto:${CONTACT.email}`} className="text-sky-400 hover:underline">
            {CONTACT.email}
          </a>
        </Row>
        <Row label="github">
          <a href={`https://${CONTACT.github}`} target="_blank" rel="noreferrer" className="text-sky-400 hover:underline">
            {CONTACT.github}
          </a>
        </Row>
        <Row label="instagram">
          <a href={`https://${CONTACT.instagram}`} target="_blank" rel="noreferrer" className="text-sky-400 hover:underline">
            {CONTACT.instagram}
          </a>
        </Row>
        <Row label="linkedin">
          <a href={`https://${CONTACT.linkedin}`} target="_blank" rel="noreferrer" className="text-sky-400 hover:underline">
            {CONTACT.linkedin}
          </a>
        </Row>
        <Row label="site">
          <a href={`https://${CONTACT.site}`} target="_blank" rel="noreferrer" className="text-sky-400 hover:underline">
            {CONTACT.site}
          </a>
        </Row>
      </div>
    </div>
  );
}